import {
  useMutation,
} from '@tanstack/react-query';
import {
  PatientMultiMediaUpdateDTO,
  PatientMultiMediaResponseDTO,
} from 'dtos';
import {
  putApiMultimediaUpdatePatientMultiMedia,
} from 'endpoints';

export default function useUpdateMediaHandler() {
  const { mutateAsync: updateMedia } = useMutation<
    PatientMultiMediaResponseDTO,
    Error,
    PatientMultiMediaUpdateDTO>({
      mutationFn: (media) => putApiMultimediaUpdatePatientMultiMedia(media),
    });

  return async (media: PatientMultiMediaUpdateDTO) => {
    await updateMedia(media);
  };
}
